import React, { useEffect, useState } from "react";

export function Gauge({ value = 0, label = "", subtitle = "", color = "green", center, overlayValue = null, overlayColor = "green", overlayLabel = "No eligible clean performance sample" }: { value?: number, label?: string, subtitle?: string, color?: string, center?: React.ReactNode, overlayValue?: number | null, overlayColor?: string, overlayLabel?: string }) {
  const strokeWidth = 12;
  const radius = 60;
  const circumference = 2 * Math.PI * radius;
  const progress = Math.min(100, Math.max(0, value));
  const offset = circumference - (progress / 100) * circumference;

  const colorMap = {
    green: "#00ff9c",
    red: "#ff4d6d",
    cyan: "#00f0ff",
    pink: "#ff00c8",
    white: "#ffffff",
    amber: "#f59e0b",
    gray: "#64748b",
  } as const;

  const ringColor = colorMap[color as keyof typeof colorMap] || "#00f0ff";
  const overlayProgress = typeof overlayValue === "number" && Number.isFinite(overlayValue) ? Math.min(100, Math.max(0, overlayValue)) : null;
  const overlayRingColor = colorMap[overlayColor as keyof typeof colorMap] || "#64748b";

  const [isClient, setIsClient] = useState(false);
  useEffect(() => setIsClient(true), []);

  return (
    <div className="relative w-full max-w-[10rem] h-[10rem]">
      {isClient && (
        <svg className="w-full h-full rotate-[-90deg]" viewBox="0 0 180 180">
          <defs>
            <filter id="glow">
              <feDropShadow dx="0" dy="0" stdDeviation="6" floodColor={ringColor} />
            </filter>
          </defs>
          <circle
            cx="90"
            cy="90"
            r={radius}
            fill="transparent"
            stroke="#111"
            strokeWidth={strokeWidth}
          />
          <circle
            cx="90"
            cy="90"
            r={radius}
            fill="transparent"
            strokeLinecap="round"
            stroke={ringColor}
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            style={{ filter: "url(#glow)" }}
            data-testid="gauge-base-ring"
          />
          {overlayProgress !== null && <circle
            cx="90"
            cy="90"
            r={52}
            fill="transparent"
            strokeLinecap="round"
            stroke={overlayRingColor}
            strokeWidth={6}
            strokeDasharray={2 * Math.PI * 52}
            strokeDashoffset={(2 * Math.PI * 52) - (overlayProgress / 100) * (2 * Math.PI * 52)}
            aria-label={overlayLabel}
            data-testid="gauge-performance-overlay"
          />}
        </svg>
      )}

      <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white">
        <div className="text-xl font-extrabold drop-shadow">{label}</div>
        <div className="text-sm font-light text-white/70">{subtitle}</div>
        <div className="text-2xl font-bold mt-1 drop-shadow">
          {center ?? (typeof value === "number" ? value.toFixed(2) : value)}
        </div>
      </div>
    </div>
  );
}